import { getBody, getById } from '../utils/dom.js';

/**
 * Handle the global site header behavior.
 *
 * @param {Document} root
 */
export function initHeader(root = document) {
  const header = getById('site-header', root);
  const toggle = getById('mobile-menu-toggle', root);
  const nav = getById('primary-navigation', root);
  const body = getBody(root);

  if (!header) {
    return;
  }

  const syncScrollState = () => {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  };

  const syncMenuState = (isOpen) => {
    if (!toggle || !nav || !body) {
      return;
    }

    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    toggle.setAttribute(
      'aria-label',
      isOpen ? 'Fechar menu principal' : 'Abrir menu principal',
    );
    nav.classList.toggle('is-open', isOpen);
    header.classList.toggle('is-menu-open', isOpen);
    body.classList.toggle('menu-open', isOpen);
  };

  const closeMenu = () => {
    nav?.querySelectorAll('[data-mobile-submenu-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.closest('.site-header__nav-item')?.classList.remove('is-submenu-open');
    });

    syncMenuState(false);
  };

  const openMenu = () => {
    syncMenuState(true);
  };

  window.addEventListener('scroll', syncScrollState, { passive: true });
  syncScrollState();

  if (!toggle || !nav || !body) {
    return;
  }

  syncMenuState(false);

  nav.querySelectorAll('[data-mobile-submenu-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      if (window.innerWidth > 900) {
        return;
      }

      event.preventDefault();

      const item = trigger.closest('.site-header__nav-item');
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      nav.querySelectorAll('[data-mobile-submenu-trigger]').forEach((otherTrigger) => {
        if (otherTrigger === trigger) {
          return;
        }

        otherTrigger.setAttribute('aria-expanded', 'false');
        otherTrigger.closest('.site-header__nav-item')?.classList.remove('is-submenu-open');
      });

      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      item?.classList.toggle('is-submenu-open', !isOpen);
    });
  });

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      closeMenu();
      return;
    }

    openMenu();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });

  document.addEventListener('click', (event) => {
    if (
      nav.classList.contains('is-open') &&
      !nav.contains(event.target) &&
      !toggle.contains(event.target)
    ) {
      closeMenu();
    }
  });

  nav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      if (window.innerWidth <= 900 && link.matches('[data-mobile-submenu-trigger]')) {
        return;
      }

      if (window.innerWidth <= 900) {
        window.setTimeout(closeMenu, 120);
      }
    });
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 900) {
      closeMenu();
    }
  });
}
